const FromArr = [{
	modelvalue: "",
	title: "唯一码：",
	inputtype: "input",
	inputflag: true,
	fontSize: 18,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "text",
	placeholder: "请输入",
	width: 240,
	height: 48,
	disabled: false,
	marginLeft: 65,
	marginTop: 10,
	displayVal: "inline-block",
	fontWeightVal: 500,
}, {
	modelvalue: "",
	title: " 批 号 ：",
	inputtype: "input",
	inputflag: true,
	fontSize: 18,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "text",
	placeholder: "请输入",
	width: 240,
	height: 48,
	disabled: false,
	marginLeft: 35,
	marginTop: 10,
	displayVal: "inline-block",
	fontWeightVal: 500,
}, {
	modelvalue: "",
	title: "产品型号/名称：",
	inputtype: "input",
	inputflag: true,
	fontSize: 18,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "text",
	placeholder: "请输入",
	width: 240,
	height: 48,
	disabled: false,
	marginLeft: 30,
	marginTop: 10,
	displayVal: "inline-block",
	fontWeightVal: 500,
}, {
	modelvalue: [],
	title: "平台： ",
	inputtype: "select",
	inputflag: true,
	fontSize: 18,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "text",
	placeholder: "请选择平台",
	width: 250,
	height: 48,
	disabled: false,
	marginLeft: 82,
	marginTop: 10,
	displayVal: "inline-block",
	fontWeightVal: 500,
	multiple: true,
	collapseTags: true,
	options: []
}, {
	title: "出库日期：",
	inputtype: "dateSection",
	inputflag: true,
	fontSize: 18,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "date",
	placeholder: "请选择",
	widthLeft: 140,
	heightLeft: 48,
	widthRight: 140,
	heightRight: 48,
	disabled: false,
	marginLeft: 25,
	marginTop: 20,
	displayVal: "inline-block",
	fontWeightVal: 500,
	StartTime: "",
	EndTime: ""
}, {
	modelvalue: [],
	title: "产品线：",
	inputtype: "select",
	inputflag: true,
	fontSize: 18,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "text",
	placeholder: "请选择产品线",
	width: 252,
	height: 48,
	disabled: false,
	marginLeft: 25,
	marginTop: 15,
	displayVal: "inline-block",
	fontWeightVal: 500,
	multiple: true,
	collapseTags: true,
	options: []
}];
export default FromArr;